import { render } from "./Dashboard.vue?vue&type=template&id=c6d92aac&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=c6d92aac&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=c6d92aac&lang=css"
script.render = render
script.__scopeId = "data-v-c6d92aac"

export default script